import { buildPermissionsFromRole } from "./rolePermissions";

export const SUPPORT_PREVIEW_QUERY = "viewAsUser";

export function getSupportPreviewUserId(search = "") {
  return new URLSearchParams(search || "").get(SUPPORT_PREVIEW_QUERY);
}

export function buildSupportPreviewUrl(tenantId, userId) {
  const params = new URLSearchParams();
  params.set(SUPPORT_PREVIEW_QUERY, userId);
  return `/tenant-dashboard/${encodeURIComponent(tenantId)}?${params.toString()}`;
}

export function withSupportPreview(path, search = "") {
  const userId = getSupportPreviewUserId(search);
  if (!userId) return path;
  const params = new URLSearchParams();
  params.set(SUPPORT_PREVIEW_QUERY, userId);
  return `${path}?${params.toString()}`;
}

export function buildReadOnlyPreviewPermissions(role) {
  const visiblePermissions = buildPermissionsFromRole(role);
  return {
    ...visiblePermissions,
    isViewOnly: true,
    canCreateEntity: false,
    canEditEntity: false,
    canUploadDocuments: false,
    canAddNotes: false,
    canRequestCreditLimit: false,
    canApprove: false,
    canSendMitigationRequest: false,
    canRequestManualEvaluation: false,
    canDeleteEntity: false,
    canVerifyEntity: false,
  };
}
